import moment from 'moment'
import {isValidMoment} from '../../utils'

// const MIN_DATE_MO = moment('1000-01-01')
// const MAX_DATE_MO = moment('3000-01-01')

moment.locale('en')

export function getWeekdays() {
  return Array
    .from({ length: 7 })
    .map((val, index) => moment().weekday(index).format('ddd'))
}

export function getMonthData({
  selected,
  year,
  month
}) {
  const mToday = moment()
  const mMonth = moment()
    .year(year)
    .month(month)
  const mStart = mMonth
    .clone()
    .startOf('month')
    .startOf('week')
  const mEnd = mMonth
    .clone()
    .month(month)
    .endOf('month')
    .endOf('week')
  const mCur = mStart.clone()
  const mSelected = isValidMoment(selected)
    ? moment(selected)
    : null
  const dates = []
  // const min = minDate ? moment(minDate).startOf('day') : MIN_DATE_MO
  // const max = maxDate ? moment(maxDate).endOf('day') : MAX_DATE_MO
  while (mCur.isBefore(mEnd)) {
    dates.push({
      time: mCur.format(),
      date: mCur.get('date'),
      isSelected: mCur.isSame(mSelected, 'day'),
      isToday: mCur.isSame(mToday, 'day'),
      isSameMonth: mCur.isSame(mMonth, 'month')
      // isDisabled: mCur.isBefore(min) || mCur.isAfter(max)
    })
    mCur.add(1, 'day')
  }
  return {
    weekdays: getWeekdays(),
    monthName: mMonth.format('MMMM YYYY'),
    dates
  }
}
